'use strict';
function shouldProcessEveryNode(node) {
  return true;
}

module.exports = {
  shouldProcessEveryNode: shouldProcessEveryNode,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/html-to-react/lib/should-process-node-definitions.js
// module id = 1074
// module chunks = 8